import { useAppActions, useAppState } from '../state/AppStateProvider';
import { SUPPORTED_CURRENCIES, getCurrencySymbol } from '../utils/format';

const CURRENCIES = SUPPORTED_CURRENCIES;

export default function CurrencySelector() {
  const { currency } = useAppState();
  const { setCurrency } = useAppActions();

  return (
    <fieldset className="currency-selector">
      <legend className="sr-only">Валюта отображения</legend>
      {CURRENCIES.map((code) => (
        <label key={code} className={currency === code ? 'currency-option active' : 'currency-option'} title={code}>
          <input
            type="radio"
            name="currency"
            value={code}
            checked={currency === code}
            onChange={() => setCurrency(code)}
          />
          <span className="currency-symbol" aria-hidden="true">{getCurrencySymbol(code)}</span>
          <span className="sr-only">{code}</span>
        </label>
      ))}
    </fieldset>
  );
}
